import { render, staticRenderFns } from "./mdc-top-app-bar-title.vue?vue&type=template&id=168e9b7c&"
import script from "./mdc-top-app-bar-title.vue?vue&type=script&lang=ts&"
export * from "./mdc-top-app-bar-title.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports